/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: 'xbaht-navbar-cart',
  templateUrl: './navbar-cart.component.html',
  styleUrl: './navbar-cart.component.scss',
  standalone: false
})
export class NavbarCartComponent implements OnInit {
  public products: any;
  public cartList = [];
  public cartListLength: number = 0;

  private _unsubscribe: Subject<void>;

  constructor(
    // public _ecommerceService: EcommerceService
    ) {
    this._unsubscribe = new Subject<void>();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeFromCart(product: any) {
    // if (product.isInCart === true) {
    //   this._ecommerceService.removeFromCart(product.id).then((res: any) => {
    //     product.isInCart = false;
    //   });
    // }
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    // this._ecommerceService.getProducts();

    // this._ecommerceService.getCartList();

    // this._ecommerceService.onCartListChange.pipe(takeUntil(this._unsubscribe)).subscribe((res: never[]) => {
    //   this.cartList = res;
    //   this.cartListLength = this.cartList.length;
    // });

    // this._ecommerceService.onProductListChange.pipe(takeUntil(this._unsubscribe)).subscribe((res: never[]) => {
    //   this.products = res;

    //   if (this.products.length) {
    //     this.products.forEach(product => {
    //       product.isInCart = this.cartList.findIndex(p => p.productId === product.id) > -1;
    //     });
    //   }
    // });
  }
}
